import React from "react";
import HeaderTransprent from "../../components/HeaderTransprent";
import Footer from "../../components/Footer";

const PrivacyandPolicy = () => {

  return (
    <>
      <HeaderTransprent />
      <section className="bg-[#2196F3]/10 w-full h-auto bg-cover bg-no-repeat bg-right" style={{ backgroundImage: `url('/img/home/sub-header-bg.webp')`, }}>
        <div className="w-full h-full">
          <div className="flex flex-col w-full h-full py-20 2xl:w-9/12 xl:w-11/12 xl:px-0 px-4 mx-auto">
            <div data-aos="fade-up" className="space-y-2 text-[#3D405B] flex flex-col justify-center items-center">
              <h2 className="xl:text-6xl text-5xl leading-[3rem] xl:leading-[3.5rem] font-bold textcolor capitalize">Privacy Policy</h2>
            </div>
          </div>
        </div>
      </section>

      <section className="px-4 py-20 mx-auto space-y-4 2xl:w-9/12 xl:w-11/12 xl:px-0">

        <h2 className="pt-4 text-xl font-semibold">SECTION 1 - WHAT DO WE DO WITH YOUR INFORMATION?</h2>
        <p>
          When you purchase something from our website store, as part of the buying and selling process, we collect personal information such as your name, address, and email address.
        </p>
        <p>Email marketing (if applicable): With your permission, we may send you emails about our existing products, new products, and other updates.</p>

        <h2 className="text-xl font-semibold">SECTION 2 - CONSENT</h2>
        <p>How do you get my consent?</p>
        <p>
          When you provide us with personal information to complete a transaction, verify your credit card, or place an order, we imply that you consent to our collecting it and using it for that specific reason only.
        </p>
        <p>
          If we ask for your personal information for a secondary reason, like marketing, we will either ask you directly for your expressed consent or provide you with an opportunity to say no.
        </p>

        <h2 className="text-xl font-semibold">SECTION 3 - DISCLOSURE</h2>
        <p>
          We may disclose your personal information if we are required by law to do so or if you violate our Terms of Service.
        </p>

        <h2 className="text-xl font-semibold">SECTION 4 - PAYMENT</h2>
        <p>
          We use Razorpay for processing payments. Razorpay does not store your card data on its servers. The data is encrypted through the Payment Card Industry Data Security Standard (PCI-DSS) when processing payments.
        </p>

        <h2 className="text-xl font-semibold">SECTION 5 - THIRD-PARTY SERVICES</h2>
        <p>
          Third-party providers will only collect, use, and disclose your information to the extent necessary to allow them to perform the services they provide to us.
        </p>

        <h2 className="text-xl font-semibold">SECTION 6 - SECURITY</h2>
        <p>
          To protect your personal information, we take reasonable precautions and follow industry best practices to ensure it is not inappropriately lost, misused, accessed, disclosed, altered, or destroyed.
        </p>

        <h2 className="text-xl font-semibold">SECTION 7 - COOKIES</h2>
        <p>We use cookies to maintain session data. They are not used to personally identify you on other websites.</p>

        <h2 className="text-xl font-semibold">SECTION 8 - AGE OF CONSENT</h2>
        <p>
          By using this site, you represent that you are at least the age of majority in your state or province of residence.
        </p>

        <h2 className="text-xl font-semibold">SECTION 9 - CHANGES TO THIS PRIVACY POLICY</h2>
        <p>
          We reserve the right to modify this privacy policy at any time, so please review it frequently. Changes and clarifications will take effect immediately upon their posting on the website.
        </p>
      </section>

      <Footer />
    </>
  );
};

export default PrivacyandPolicy;
